import api from '@/api'

export default {
    getMyCalendarFolderId(): Promise<string> {
        return api.get<string>({
            url: '/Portal/ReservationEws/api/myCalendarFolder'
        })
    },

    getEwsResources(): Promise<ewsResource.EwsResourceItem[]> {
        return api.get<ewsResource.EwsResourceItem[]>({
            url: '/Portal/ReservationEws/api/resources'
        })
    },

    getAvailableRooms(param: reserve.AvailableResourceRequest): Promise<ewsResource.EwsResourceItem[]> {
        return api.post<ewsResource.EwsResourceItem[]>({
            url: '/Portal/ReservationEws/api/availableResources',
            data: param
        })
    },   

    /**
     * 폴더의 일정들을 가져옵니다 (반복일정 포함)
     * @param {string} parentId root folder ID
     * @param {string} startdate 시작일
     * @param {string} enddate 종료일
     */
     getResourceEventListWithRecurrence(item: reserve.SearchOptions) {
        return api.post<Array<any>>({
            url: `/Portal/ReservationEws/api/resourceEvents`,
            data: {
                EwsFolderIDArray: item.EwsFolderIDArray || null,
                EwsFolderID: item.ParentFolderID || null, 
                StartDate: item.StartDate || null, 
                EndDate: item.EndDate || null, 
                Status: item.Status || null,
                Subject: item.Subject || null,
                Location: item.Location || null, 
                OrganizerName: item.OrganizerName || null,
                OrganizerAddress: item.OrganizerAddress || null, 
                PersonCode: item.PersonCode, 
                RequiredAttendees: null, 
                OptionalAttendees: null, 
                EumNoCondition: false, 
                EumPageNumber: item.EumPageNumber || 1, 
                EumRowsPerPage: item.EumRowsPerPage || 9999, 
                IpUsers: item.IpUsers || null
            }
        }).then((res) => {
            return res.map((data) => {
                var subject = data.subject as string || '';
                var organizerName = data.organizer.name as string;
                var findIdx = subject.indexOf(organizerName);

                if(findIdx == 0) {
                    subject = subject.replace(organizerName, '');
                }

                let result = {
                    ...data,
                    subject: subject,
                    isEWS: true,
                };
                return result;
            });
        });;
    },

    searchCalendarEventList(item: reserve.EventSearchRequest, resourceUpn: string) {
        return api.post<Array<any>>({
            url: `/Portal/ReservationEws/api/searchEvents?resource=${encodeURIComponent(resourceUpn)}`,
            data: item
        }).then((res) => {
            return res.map((data) => {
                var subject = data.subject as string || '';
                var organizerName = data.organizer.name as string;
                var findIdx = subject.indexOf(organizerName);

                if(findIdx == 0) {
                    subject = subject.replace(organizerName, '');
                }

                let result = {
                    ...data,
                    subject: subject,
                    isEWS: true,
                };
                return result;
            });
        });
    },

    deleteAttachment(id: string, attachmentIds: string[]) {
        return api.post<boolean>({
            url: '/Mail/Attachment/api/deleteAttachment',
            data: {
                itemId: id,
                attachmentIds: attachmentIds,
            },
        })
    }
}